import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiService from "../../service";
import { toast } from "react-toastify";
import ShowToast from "../Common/ReactToastifyNotification/Toastify";
import "./VerificationId.css";

const Verification = () => {
  const { verificationId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const verifyUser = async () => {
      if (!verificationId) return;
      const token = localStorage.getItem("token");

      if (!token) {
        navigate("/login");
        return;
      }
      try {
        const verifyResponse = await apiService.verificationValid({
          verificationId: verificationId,
        });

        if (verifyResponse?.status === "true") {
          ShowToast.success(verifyResponse.message);

          navigate("/login");
          return;
        }
      } catch (err) {
        console.error("Verification failed, Please Login", err);
        ShowToast.error("Verification failed, Please Login");
        navigate("/login");
      }
    };

    verifyUser();
  }, [verificationId, navigate]);

  return (
    <>
      <Typography variant="h3" className="verify-test">
        Verification Completed successfully.
      </Typography>
    </>
  );
};

export default Verification;
